module.exports = __webpack_public_path__ + "img/31_6.0459cd56.png";